import { IBase } from "src/app/core/models/base";
import { TimeSpan } from "src/app/shared/helpers/time-span";

export interface IService extends IBase{
    name: string,
    defaultTime: string,
    defaultTimeObj: TimeSpan,
    category: ServiceCategories,
    timeEntryCategoryId: string
}

export enum ServiceCategories {
    internal = 0,
    external = 1
}

export interface ICreateServiceRequest{
    name: string,
    defaultTime: string,
    category: ServiceCategories
}

export interface IUpdateServiceRequest{
    id: string,
    name: string,
    defaultTime: string,
    category: ServiceCategories
}
